module.exports = __webpack_public_path__ + "assets/img/35_1113.8722f299.jpg";